import { render, staticRenderFns } from "./MyLiked.vue?vue&type=template&id=0701df0a&scoped=true&"
import script from "./MyLiked.vue?vue&type=script&lang=js&"
export * from "./MyLiked.vue?vue&type=script&lang=js&"
import style0 from "./MyLiked.vue?vue&type=style&index=0&id=0701df0a&prod&scoped=true&lang=css&"
import style1 from "./MyLiked.vue?vue&type=style&index=1&id=0701df0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0701df0a",
  null
  
)

export default component.exports